<template>
  <div>
    <router-view v-show="$route.matched.length==3"></router-view>
    <PageHeaderLayout v-show="$route.matched.length==2">
      <div class="main-page-content">


        <!-- 操作按钮区域 -->
        <div class="action-card">
          <div class="action-buttons">
            <el-button 
              type="primary" 
              size="medium" 
              class="action-btn primary-btn"
              @click="addButton()">
              <i class="el-icon-plus"></i>
              <span>添加内容</span>
            </el-button>
          </div>
        </div>

        <!-- 搜索筛选区域 -->
        <div class="search-card">
          <div class="search-header">
            <h3 class="search-title">
              <i class="el-icon-search"></i>
              搜索筛选
            </h3>
          </div>
          <div class="search-content">
            <el-form size="medium" :inline="true" :model="searchCondition" class="search-form">
              <div class="form-row">
                <el-form-item label="显示语言" class="form-item">
                  <el-select v-model="searchCondition.lang" placeholder="原文" clearable @change="searchButton" style="width:140px">
                    <el-option v-for="l in contentLocales" :key="l" :label="localeLabel(l)" :value="l"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="标题搜索" class="form-item">
                  <div class="input-wrapper">
                    <el-input 
                      v-model="searchCondition.title" 
                      placeholder="输入标题关键词" 
                      clearable
                      prefix-icon="el-icon-edit">
                    </el-input>
                  </div>
                </el-form-item>
                
                <el-form-item label="发布时间" class="form-item">
                  <div class="input-wrapper">
                    <el-date-picker
                      v-model="searchCondition.time_value"
                      type="daterange"
                      align="right"
                      unlink-panels
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      value-format="yyyy-MM-dd"
                      prefix-icon="el-icon-date">
                    </el-date-picker>
                  </div>
                </el-form-item>
                
                <el-form-item label="状态筛选" class="form-item">
                  <div class="input-wrapper">
                    <el-select 
                      v-model="searchCondition.article_status" 
                      placeholder="选择状态"
                      clearable
                      prefix-icon="el-icon-check">
                      <el-option
                        v-for="item in article_status"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </div>
                </el-form-item>
                
                <el-form-item class="form-item" style="margin-left: 60px;">
                  <div class="button-group">
                    <el-button 
                      type="primary" 
                      class="search-btn"
                      @click="searchButton">
                      <i class="el-icon-search"></i>
                      查询
                    </el-button>
                    <el-button 
                      class="reset-btn"
                      @click="resetSearch">
                      <i class="el-icon-refresh-left"></i>
                      重置
                    </el-button>
                  </div>
                </el-form-item>
              </div>
            </el-form>
          </div>
        </div>

        <!-- 数据表格区域 -->
        <div class="table-card">
          <div class="table-header">
            <h3 class="table-title">
              <i class="el-icon-tickets"></i>
              内容列表
            </h3>
            <div class="table-tools">
              <span class="data-count">共 {{pagingData.total}} 条记录</span>
            </div>
          </div>
          
          <ApeTable 
            ref="apeTable" 
            :data="articleList"  
            :loading="loadingStaus" 
            :pagingData="pagingData" 
            @switchPaging="switchPaging" 
            highlight-current-row
            class="modern-table">
            
            <el-table-column
              slot="first-column"
              width="80"
              align="center"
              label="排序">
              <template slot-scope="scope">
                <div class="drag-wrapper">
                  <el-tooltip effect="dark" content="拖动排序" placement="top">
                    <span class="drag-handle" :data-id="scope.row.id" :data-parent_id="scope.row.pid" :data-depth="scope.row.depth">
                      <i class="el-icon-rank"></i>
                    </span>
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>
            
            <el-table-column
              width="80"
              label="序号"
              align="center">
              <template slot-scope="scope">
                <div class="index-cell">
                  {{offset+scope.$index+1}}
                </div>
              </template>
            </el-table-column>
            
            <el-table-column
              width="140"
              label="封面"
              align="center">
              <template slot-scope="scope">
                <div class="cover-cell">
                  <div class="cover-wrapper">
                    <img :src="getallUrl(scope.row.cover_url)" class="cover-image" />
                    <div class="cover-overlay">
                      <i class="el-icon-zoom-in"></i>
                    </div>
                  </div>
                </div>
              </template>
            </el-table-column>
            
            <el-table-column
              label="基本信息"
              min-width="300">
              <template slot-scope="scope">
                <div class="info-cell">
                  <div class="info-title">
                    <i class="el-icon-document"></i>
                    {{scope.row.title}}
                  </div>
                  <div class="info-meta">
                    <span class="meta-item">
                      <i class="el-icon-time"></i>
                      {{scope.row.published_time}}
                    </span>
                    <span class="meta-item type-tag">
                      <i class="el-icon-collection-tag"></i>
                      <span v-if="scope.row.article_type==1" class="tag blog-tag">博客</span>
                      <span v-else-if="scope.row.article_type==2" class="tag news-tag">新闻</span>
                      <span v-else class="tag case-tag">案例</span>
                    </span>
                  </div>
                </div>
              </template>
            </el-table-column>
            
            <el-table-column
              label="SEO信息"
              min-width="250">
              <template slot-scope="scope">
                <div class="seo-cell">
                  <div class="seo-item">
                    <span class="seo-label">标题：</span>
                    <span class="seo-value">{{scope.row.seo_title}}</span>
                  </div>
                  <div class="seo-item">
                    <span class="seo-label">关键字：</span>
                    <span class="seo-value">{{scope.row.seo_keywords}}</span>
                  </div>
                  <div class="seo-item">
                    <span class="seo-label">描述：</span>
                    <span class="seo-value">{{scope.row.seo_description}}</span>
                  </div>
                </div>
              </template>
            </el-table-column>
            
            <el-table-column
              label="摘要标签"
              min-width="200">
              <template slot-scope="scope">
                <div class="excerpt-cell">
                  <div class="excerpt-content">
                    <i class="el-icon-document-copy"></i>
                    {{scope.row.excerpt}}
                  </div>
                  <div class="tags-content">
                    <i class="el-icon-price-tag"></i>
                    {{scope.row.tags}}
                  </div>
                </div>
              </template>
            </el-table-column>
            
            <el-table-column
              label="状态"
              width="120"
              align="center">
              <template slot-scope="scope">
                <div class="status-cell">
                  <el-switch
                    v-model="scope.row.article_status"
                    active-color="#67C23A"
                    inactive-color="#F56C6C"
                    active-value="1"
                    inactive-value="0"
                    class="status-switch"
                    @change="changeStatus(scope.row)">
                  </el-switch>
                  <div class="status-text">
                    {{scope.row.article_status === '1' ? '已启用' : '已禁用'}}
                  </div>
                </div>
              </template>
            </el-table-column>
            
            <el-table-column
              width="160"
              label="操作"
              align="center">
              <template slot-scope="scope">
                <div class="action-cell">
                  <el-tooltip effect="dark" content="编辑内容" placement="top">
                    <el-button 
                      size="small" 
                      type="primary" 
                      icon="el-icon-edit" 
                      class="table-action-btn edit-btn"
                      @click="editButton(scope.row.id)">
                    </el-button>
                  </el-tooltip>
                  <el-popconfirm
                    :title="`确定删除该${contentTypeLabel}吗？`"
                    confirm-button-text="删除"
                    cancel-button-text="取消"
                    @confirm="deleteButton(scope.row.id)">
                    <el-button
                      slot="reference"
                      size="small"
                      type="danger"
                      icon="el-icon-delete"
                      class="table-action-btn delete-btn"
                      :title="`删除${contentTypeLabel}`">
                    </el-button>
                  </el-popconfirm>
                </div>
              </template>
            </el-table-column>
          </ApeTable>
        </div>
      </div>
    </PageHeaderLayout>
  </div>
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import ApeTable from '@/components/ApeTable'
import ApeDrawer from '@/components/ApeDrawer'
import ApeUploader from '@/components/ApeUploader'
import ModalDialog from '@/components/ModalDialog'
import Sortable from 'sortablejs'
import { mapGetters } from 'vuex'

export default {
  components: {
    PageHeaderLayout,
    ApeDrawer,
    ApeTable,
    ApeUploader,
    ModalDialog
  },
  data() {
    return {
      contentLocales: ['en', 'zh', 'tw', 'ar', 'es', 'ru', 'nl', 'pl', 'it', 'fr', 'de', 'pt', 'ja', 'ko', 'hi', 'tr', 'id', 'ur', 'vi', 'th'],
      searchCondition:{
        current_page: 1,
        page_size: 20,
        lang: 'en',
        query:"article_type=?",
        order_by: "article_rank asc",
        params:[]
      },
      loadingStaus: true,
      article_status:[
        {label:'启用',value:1},
        {label:'禁用',value:0},
      ],
      // 表格列表数据
      articleList:[],
      // 分页信息
      pagingData:{
        page_size: 20,
        current_page: 1,
        is_show: true,
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0
      },
      // 分页的offset,序号列使用
      offset:0,
      // 已上传文件列表
      uploadFileList:[],
      // 表单验证
      rules: {
        title: [
          {required: true, message: '输入标题', trigger: 'blur' },
        ],
        type: [
          {required: true, message: '选择类型', trigger: 'blur' },
        ],
        is_new_win: [
          {required: true, message: '选择打开发方式', trigger: 'blur' },
        ],
        is_show: [
          {required: true, message: '选择状态', trigger: 'blur' },
        ],
        image: [
          {required: true, message: '上传图片', trigger: 'blur', validator:this.apeUploaderVerify},
        ],
      },
      // 抽屉数据，附件列表
      drawerData: {
        visible: false,
        loading: true,
        loading_text: '玩命加载中……',
        // direction: 'right',
        title: '',
        width_height: '640px',
        show_footer:false,
        // mask: false,
        // close_name: '关 闭',
        // confirm_name: '打 印',
      },
      // 添加附件
      dialogData:{
        visible: false,
        title: '',
        width: '24%',
        loading: true,
        modal: false
      },
      // 附件表单内容
      formData:{},
      // 附件添加表单验证
      dialogRules: {
        title: [{required: true, message: '输入标题', trigger: 'blur' }],
      },
      currentArticleId:0,
    }
  },
  computed: {
    ...mapGetters(['userPermissions','buttonType']),
    contentTypeLabel() {
      if (this.$route.path.indexOf('blog') !== -1) return '博客'
      if (this.$route.path.indexOf('case') !== -1) return '案例'
      return '文章'
    }
  },
  watch: {
    "$route.matched" : function(n) {
    if (n.length === 2) {
        this.list()
      }
    }
  },
  methods: {
    // 搜索
    getallUrl(url){
      if(url==null || url=='' || url==undefined){
        return ''
      }
      if(url.startsWith("http")){
        return url
      }else if(url.startsWith("/")){
        return window.location.origin + url
      }else{
        return window.location.origin + "/" + url
      }
    },
    searchButton() {
      this.$refs['apeTable'].currentPage=1
      this.list()
    },
    // 重置搜索
    resetSearch() {
      this.searchCondition.title = ''
      this.searchCondition.time_value = null
      this.searchCondition.article_status = ''
      this.searchButton()
    },
    // 切换页码操作
    async switchPaging() {
      this.list()
    },
    // 响应添加按钮
    addButton() {
      let type = 'article'
      if (this.$route.path.indexOf('blog') !== -1) {
        type = 'blog'
      } else if (this.$route.path.indexOf('case') !== -1) {
        type = 'case'
      }
      this.$router.push(`/cms/${type}/create`)
    },
    // 响应编辑按钮
    editButton(id) {
      let type = 'article'
      if (this.$route.path.indexOf('blog') !== -1) {
        type = 'blog'
      } else if (this.$route.path.indexOf('case') !== -1) {
        type = 'case'
      }
      this.$router.push(`/cms/${type}/edit/${id}`)
    },
    // 相应删除按钮
    async deleteButton(id) {
      let res = await this.$api.post('/service/ola_app_article/delete',{id:id})
      if (this.$apiSuccess(res)) {
        this.$message.success(`${this.contentTypeLabel}删除成功!`)
        this.list()
      } else {
        this.$message.error(res.message || `${this.contentTypeLabel}删除失败!`)
      }
      
    },
    async changeStatus(row){
      let res = await this.$api.post('/service/ola_app_article/update',row)
      if (this.$apiSuccess(res)){
        this.$message.success('修改状态成功!')
      }else{
        this.$message.error(res.message)
      }
    },
    // 处理抽屉关闭
    drawerClose() {
      this.drawerData.visible = false
      this.drawerData.loading = true
    },
    // 初始化新闻列表
    async list() {
      this.loadingStaus=true
      this.handleSearchCondition()
      let res = await this.$api.post('/service/ola_app_article/list',this.searchCondition)
      if (this.$apiSuccess(res)){
        this.articleList = res.data.list
        this.pagingData.total = res.data.page.total
        this.loadingStaus=false
      }else{
        this.$message.error(res.message)
      }
    },
    // 处理搜索条件
    handleSearchCondition() {
      let pagingInfo = this.$refs['apeTable'].getPagingInfo()
      this.searchCondition.page_size = pagingInfo.page_size
      this.searchCondition.current_page = pagingInfo.current_page
      this.searchCondition.params = []
      this.searchCondition.query = 'article_type=?'
      if (this.$route.path.indexOf('blog') != -1){
        this.searchCondition.params = ["1"]
      }
      if (this.$route.path.indexOf('article') != -1){
        this.searchCondition.params = ["2"]
      }
      if (this.$route.path.indexOf('case') != -1){
        this.searchCondition.params = ["3"]
      }
      if (this.searchCondition.title) {
        this.setSearchCondition(' INSTR(title,?) ',this.searchCondition.title)
      }
      if (this.searchCondition.time_value) {
        this.setSearchCondition(' published_time  >= ? ',this.searchCondition.time_value[0])
        this.setSearchCondition(' published_time  <= ? ',this.searchCondition.time_value[1])
      }
      if (this.searchCondition.article_status) {
        this.setSearchCondition(' article_status = ? ',this.searchCondition.article_status)
      }
    },
    setSearchCondition(condition,v) {
      if (this.searchCondition.query == '' ){
          this.searchCondition.query = condition
        }else{
          this.searchCondition.query = this.searchCondition['query'] + ' and ' + condition
        }
      this.searchCondition.params.push(v)
    },
    // form数据提交，请求接口,新闻附件
    async formSubmit() {
      this.dialogData.loading_text = '玩命提交中……'
      this.dialogData.loading = true
      let url = '/service/ola_app_article/create'
      if (this.formData.id != '') {
        url = '/service/ola_app_article/update'
      }
      let res = await this.$api.post(url,this.formData)
      if (this.$apiSuccess(res)) {
        this.$message.success('保存成功!')
        this.list()
      }else{
        this.$message.error(res.message)
      }
    },
    // 处理模态框，确定事件
    handleConfirm() {
      // 调用组件的数据验证方法
      this.$refs['articleAttacmentForm'].validate((valid) => {
        if (valid) {
          this.formSubmit()
        } else {
          this.$message.error('数据验证失败，请检查必填项数据！')
        }
      })
    },
    // 处理模态框，关闭事件
    dialogClose() {
      this.dialogData.visible = false
      this.dialogData.loading = true
      this.formData = {}
    },
     // 拖拽排序数据提交，请求接口
     async dragSortSubmit(orderIds) {
      let res = await this.$api.post('/service/ola_app_article/order',{orderIds:orderIds,sort_field:'article_rank'})
      if (this.$apiSuccess(res)){
        this.$message.success('排序成功!')
        this.list()
      }else{
        this.$message.error('排序失败!')
      }
    },
    // 表格拖拽排序，同层级移动有效果
    dragSort() {
      const el = document.querySelectorAll('.el-table__body-wrapper > table > tbody')[0]
      this.sortable = Sortable.create(el,{
        handle: ".drag-handle", 
        setData: function(dataTransfer) {
          dataTransfer.setData('Text', '')
        },
        onEnd: () => {
          let Ids = []
          let tmp = el.querySelectorAll('.drag-handle')
          for (let i=0,len=tmp.length; i < len; i++) {
            Ids.push(tmp[i].dataset.id)
          }
          this.dragSortSubmit(Ids)
        },
      })
    },
    localeLabel(l) {
      return ({
        en: 'English（英语）', zh: '中文（简体）', tw: '中文（繁體）', ar: 'العربية（阿拉伯语）',
        es: 'Español（西班牙语）', ru: 'Русский（俄语）', nl: 'Nederlands（荷兰语）', pl: 'Polski（波兰语）',
        it: 'Italiano（意大利语）', fr: 'Français（法语）', de: 'Deutsch（德语）', pt: 'Português（葡萄牙语）',
        ja: '日本語（日语）', ko: '한국어（韩语）', hi: 'हिन्दी（印地语）', tr: 'Türkçe（土耳其语）',
        id: 'Bahasa Indonesia（印尼语）', ur: 'اردو（乌尔都语）', vi: 'Tiếng Việt（越南语）', th: 'ไทย（泰语）'
      })[l] || l
    },
    async loadI18nMeta() {
      try {
        const res = await this.$api.post('/service/i18n/meta', {})
        if (this.$apiSuccess(res)) {
          this.contentLocales = res.data.content_locales || this.contentLocales
          this.searchCondition.lang = res.data.source_locale || 'en'
        }
      } catch (e) {
        // meta optional
      }
    }
  },
  async mounted() {
    await this.loadI18nMeta()
    this.list()
    this.$nextTick(() => {
      this.dragSort()
    })
  },
}
</script>

<style lang="stylus" scoped>
.main-page-content
  padding 0
  
// 页面标题区域
.page-title-section
  background linear-gradient(135deg, #667eea 0%, #764ba2 100%)
  padding 32px
  margin-bottom 24px
  border-radius 12px
  color #fff
  
  .title-content
    .page-title
      font-size 28px
      font-weight 600
      margin 0 0 8px 0
      display flex
      align-items center
      gap 12px
      
      i
        font-size 32px
        opacity 0.9
        
    .page-subtitle
      font-size 16px
      opacity 0.9
      margin 0

// 操作卡片
.action-card
  background #fff
  border-radius 12px
  padding 24px
  margin-bottom 24px
  box-shadow 0 2px 12px rgba(0,0,0,0.1)
  border 1px solid #f0f0f0
  
  .action-header
    margin-bottom 16px
    
    .action-title
      font-size 16px
      font-weight 600
      color #303133
      margin 0
      
  .action-buttons
    display flex
    gap 12px
    
    .action-btn
      height 40px
      padding 0 20px
      border-radius 8px
      font-weight 500
      transition all 0.3s ease
      
      &.primary-btn
        background linear-gradient(135deg, #409EFF 0%, #66B3FF 100%)
        border none
        box-shadow 0 4px 12px rgba(64,158,255,0.3)
        
        &:hover
          transform translateY(-2px)
          box-shadow 0 6px 16px rgba(64,158,255,0.4)

// 搜索卡片
.search-card
  background #fff
  border-radius 12px
  padding 24px
  margin-bottom 24px
  box-shadow 0 2px 12px rgba(0,0,0,0.1)
  border 1px solid #f0f0f0
  
  .search-header
    margin-bottom 20px
    border-bottom 1px solid #f0f0f0
    padding-bottom 12px
    
    .search-title
      font-size 16px
      font-weight 600
      color #303133
      margin 0
      display flex
      align-items center
      gap 8px
      
      i
        color #409EFF
        
  .search-content
    .search-form
      .form-row
        display flex
        flex-wrap wrap
        gap 16px
        align-items flex-end
        
        .form-item
          flex none
          margin-bottom 16px
          
          .input-wrapper
            /deep/ .el-input
              width 200px
              
              .el-input__inner
                border-radius 8px
                border 2px solid #f0f0f0
                transition all 0.3s ease
                
                &:focus
                  border-color #409EFF
                  box-shadow 0 0 0 2px rgba(64,158,255,0.1)
                  
            /deep/ .el-date-editor
              width 300px
              
            /deep/ .el-select
              width 150px
              
          .button-group
            display flex
            gap 8px
            
            .search-btn
              background linear-gradient(135deg, #409EFF 0%, #66B3FF 100%)
              border none
              border-radius 8px
              padding 10px 20px
              font-weight 500
              box-shadow 0 2px 8px rgba(64,158,255,0.3)
              
              &:hover
                transform translateY(-1px)
                box-shadow 0 4px 12px rgba(64,158,255,0.4)
                
            .reset-btn
              border 2px solid #f0f0f0
              border-radius 8px
              padding 8px 18px
              color #606266
              background #fff
              
              &:hover
                border-color #409EFF
                color #409EFF

// 表格卡片
.table-card
  background #fff
  border-radius 12px
  padding 24px
  box-shadow 0 2px 12px rgba(0,0,0,0.1)
  border 1px solid #f0f0f0
  
  .table-header
    display flex
    justify-content space-between
    align-items center
    margin-bottom 20px
    padding-bottom 12px
    border-bottom 1px solid #f0f0f0
    
    .table-title
      font-size 16px
      font-weight 600
      color #303133
      margin 0
      display flex
      align-items center
      gap 8px
      
      i
        color #409EFF
        
    .table-tools
      .data-count
        color #909399
        font-size 14px

// 表格样式
.modern-table
  /deep/ .el-table
    border-radius 8px
    overflow hidden
    
    .el-table__header
      background #f8f9fa
      
      th
        background #f8f9fa !important
        color #303133
        font-weight 600
        border-bottom 2px solid #e4e7ed
        
    .el-table__body
      tr
        transition all 0.3s ease
        
        &:hover
          background-color #f5f7fa
          
        td
          border-bottom 1px solid #f0f0f0
          
// 表格单元格样式
.drag-wrapper
  .drag-handle
    display inline-flex
    align-items center
    justify-content center
    width 32px
    height 32px
    border-radius 6px
    background #f0f0f0
    color #909399
    cursor grab
    transition all 0.3s ease
    
    &:hover
      background #409EFF
      color #fff
      transform scale(1.1)
      
    &:active
      cursor grabbing

.index-cell
  font-weight 600
  color #409EFF
  background #f0f8ff
  padding 4px 8px
  border-radius 6px
  display inline-block

.cover-cell
  .cover-wrapper
    position relative
    width 80px
    height 80px
    border-radius 8px
    overflow hidden
    cursor pointer
    transition all 0.3s ease
    
    &:hover
      transform scale(1.05)
      
      .cover-overlay
        opacity 1
        
    .cover-image
      width 100%
      height 100%
      object-fit cover
      
    .cover-overlay
      position absolute
      top 0
      left 0
      width 100%
      height 100%
      background rgba(0,0,0,0.5)
      display flex
      align-items center
      justify-content center
      color #fff
      font-size 20px
      opacity 0
      transition all 0.3s ease

.info-cell
  .info-title
    font-size 16px
    font-weight 600
    color #303133
    margin-bottom 8px
    display flex
    align-items center
    gap 8px
    
    i
      color #409EFF
      
  .info-meta
    display flex
    gap 16px
    
    .meta-item
      display flex
      align-items center
      gap 4px
      font-size 14px
      color #909399
      
      i
        font-size 14px
        
      &.type-tag
        .tag
          padding 2px 8px
          border-radius 4px
          color #fff
          font-size 12px
          font-weight 500
          
          &.blog-tag
            background #67C23A
            
          &.news-tag
            background #E6A23C
            
          &.case-tag
            background #F56C6C

.seo-cell
  .seo-item
    margin-bottom 6px
    font-size 14px
    
    &:last-child
      margin-bottom 0
      
    .seo-label
      color #909399
      font-weight 500
      
    .seo-value
      color #606266

.excerpt-cell
  .excerpt-content
    display flex
    align-items flex-start
    gap 6px
    margin-bottom 8px
    font-size 14px
    color #606266
    
    i
      color #909399
      margin-top 2px
      
  .tags-content
    display flex
    align-items flex-start
    gap 6px
    font-size 14px
    color #909399
    
    i
      margin-top 2px

.status-cell
  display flex
  flex-direction column
  align-items center
  gap 8px
  
  .status-switch
    /deep/ .el-switch__core
      border-radius 10px
      
  .status-text
    font-size 12px
    color #909399

.action-cell
  display flex
  align-items center
  justify-content center
  gap 8px

  .table-action-btn
    width 32px
    height 32px
    border-radius 6px
    padding 0
    display inline-flex
    align-items center
    justify-content center
    transition all 0.3s ease
    
    &.edit-btn
      background #409EFF
      border-color #409EFF
      
      &:hover
        background #66B3FF
        transform translateY(-2px)
        box-shadow 0 4px 12px rgba(64,158,255,0.3)

    &.delete-btn
      background #F56C6C
      border-color #F56C6C
      color #fff

      &:hover
        background #F78989
        transform translateY(-2px)
        box-shadow 0 4px 12px rgba(245,108,108,0.3)

// 响应式设计
@media (max-width: 1200px)
  .search-content
    .search-form
      .form-row
        .form-item
          .input-wrapper
            /deep/ .el-input
              width 180px
              
            /deep/ .el-date-editor
              width 260px

@media (max-width: 768px)
  .page-title-section
    padding 20px
    
    .title-content
      .page-title
        font-size 24px
        
  .action-card, .search-card, .table-card
    padding 16px
    
  .search-content
    .search-form
      .form-row
        flex-direction column
        align-items stretch
        
        .form-item
          width 100%
          
          .input-wrapper
            /deep/ .el-input, /deep/ .el-date-editor, /deep/ .el-select
              width 100%
</style>
